import serverCode from '../../serverCode'

const defaultState = () => ({
  items: [],
})

const state = defaultState()

const getters = {}

const mutations = {
  setItems(state, payload) {
    state.items = payload
  },
  resetItems(state) {
    Object.assign(state, defaultState())
  },
}

const actions = {
  async getItems({ commit, rootState }) {
    try {
      const { succeed, reportArticles } = await serverCode(
        'getReportArticleRanking',
        {},
        rootState.locale
      )
      if (!succeed) {
        throw new Error()
      } else {
        commit('setItems', reportArticles)
      }
    } catch (error) {
      //
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
